<template>
  <div>
    <ChartLegend
      v-for="legend in legends"
      :key="legend.color"
      :legend="legend" />
  </div>
</template>

<script>
import ChartLegend from '@/components/charts/ChartLegend.vue'
export default {
  components: {
    ChartLegend
  },
  props: {
    legends: {
      type: Array,
      default: () => []
    },
  }
}
</script>

<style>

</style>